<template>
    <h1>404！页面未找到！！！</h1>
</template>

<script>
    export default {
        name: "404"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/err/404.vue